import { Component, OnInit, ViewChild } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatProgressBar } from '@angular/material/progress-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { CustomValidators } from '../../../shared/services/custom.validators';
import { JwtAuthService } from '../../../shared/services/auth/jwt-auth.service';
import { NotificationService} from '../../../shared/services/notification.service';
import { AppLoaderService } from '../../../shared/services/app-loader/app-loader.service';


@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {


  form: FormGroup;
  userEmail;
  @ViewChild(MatProgressBar) progressBar: MatProgressBar;
  @ViewChild(MatButton) submitButton: MatButton;
  constructor(
    private jwtAuth: JwtAuthService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private loader: AppLoaderService,
    private notificationService: NotificationService
  ) {
    this.form = this.toForm();
   }

  ngOnInit() {
  }
  submitEmail() {
    // console.log(this.form.value);
    this.submitButton.disabled = true;
    this.loader.open();
    this.jwtAuth.newRecoverPasswordForgot(this.form.value).subscribe(res =>{
      this.loader.close();
      this.notificationService.success("Hemos enviado su nueva contraseña a su correo  !!!. Revise y pruebe iniciar sesion nuevamente")
      this.router.navigateByUrl("/sessions/signin");
    }, err =>{
      this.loader.close();
      this.notificationService.error(err)

    });
    
  }

  private toForm(): FormGroup {
		return this.fb.group({
			email: new FormControl('', [Validators.required, CustomValidators.emailRegex, Validators.maxLength(100)])
		});
	}
}
